module.exports = __webpack_public_path__ + "static/apple-icon-180x180-d7c0cf97eb19ff6dfe8beba2b061b64f.png";